import { Alert, Divider, Fieldset, Stack, Text } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { IconAlertTriangle, IconInfoTriangle } from "@tabler/icons-react";
import type { PropsWithChildren } from "react";
import type { Coach } from "../../../models/coach";
import type { Report } from "../../../models/reports/report";
import { SaveButton } from "../../button/SaveButton";
import { CommonReportForm, type CommonReportFormErrors, type CommonReportFormType } from "./CommonReportForm";

type BaseReportFormProps<T extends CommonReportFormType> = PropsWithChildren<{
  report: Report;
  errors: CommonReportFormErrors & {
    data?: string[];
  };
  onSubmit: () => void;
  form: UseFormReturnType<T>;
  coaches: Coach[];
  saveButtonLabel: string;
  saveButtonDisabled?: boolean;
}>;

export function BaseReportForm<T extends CommonReportFormType>({
  children,
  report,
  errors,
  onSubmit,
  form,
  coaches,
  saveButtonLabel,
  saveButtonDisabled = false,
}: BaseReportFormProps<T>) {
  return (
    <form onSubmit={onSubmit}>
      <Fieldset title="Details" disabled={report?.document?.publish}>
        <Stack maw="60rem">
          {errors?.data && (
            <Alert maw="60rem" variant="light" icon={<IconAlertTriangle />} title="Struktureller Fehler" color="red">
              <Text>{errors?.data}</Text>
            </Alert>
          )}
          {report?.document?.publish && (
            <Alert maw="60rem" variant="light" icon={<IconInfoTriangle />} title="Bereits freigegebenes Dokument" color="zli-orange">
              <Text>
                Für diesen Bericht gibt es bereits ein freigegebenes Dokument. Falls Sie diesen Bericht bearbeiten möchten, müssen Sie
                zuerst das Dokument zurückziehen.
              </Text>
            </Alert>
          )}
          <CommonReportForm errors={errors} form={form} report={report} coaches={coaches} />
          {children}
          <Divider />
          <SaveButton disabled={saveButtonDisabled} label={saveButtonLabel} />
        </Stack>
      </Fieldset>
    </form>
  );
}
